



export const priceGranularity = {
    buckets: [
        {
            max: 100,
            increment: 0.01,
        },
        {
            max: 500,
            increment: 1,
        },
    ],
};
